export function isOneOf<T>(value: unknown, valid: ReadonlyArray<T>): value is T {
    return valid.includes(value as any);
}
